import gql from 'graphql-tag'

const utenti = gql`
  query utenti (
    $limit: Int!,
    $offset: Int,
    $where: UtentiFilterInput
  ) {
    utenti (
      limit: $limit,
      offset: $offset,
      where: $where
    ) {
      totalCount
      nodes {
        id
        nome
        email
        ruolo
      }
    }
  }
`

export default utenti


// WEBPACK FOOTER //
// ./src/graphql/queries/utenti.js